import { useState } from 'react';
import { Segmented } from 'antd';

import PowerPointLogo from '~/assets/powerpoint.svg';
// import ExcelLogo from '~/assets/excel.svg';
import WordLogo from '~/assets/word.svg';
import OutlookLogo from '~/assets/outlook.svg';
import TeamsLogo from '~/assets/teams.svg';
import { BrowseIntegrationsButton } from '../Testimonials';

const generateCloudFlareVideoUrlByid = (videoId) =>
    `https://customer-b5iz2r6cpeptxyuk.cloudflarestream.com/${videoId}/iframe?muted=true&preload=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-b5iz2r6cpeptxyuk.cloudflarestream.com%2F${videoId}%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&controls=true`;

const slides = [
    {
        label: 'Outlook',
        url: 'https://www.youtube-nocookie.com/embed/rFFVExX6z5g?si=dq0m-3Diq1IMrhZo',
        icon: (
            <img
                className='inline-block'
                style={{ height: '30px' }}
                src={OutlookLogo}
                alt='outlook logo'
            />
        ),
    },
    {
        label: 'PowerPoint',
        videoId: '4d921d19e9a487fd31bd40364064f064',
        url: 'https://www.youtube-nocookie.com/embed/fq0UQ9oMyck?si=Icf_DDLbgFJhicHp',
        icon: (
            <img
                className='inline-block'
                style={{ height: '30px' }}
                src={PowerPointLogo}
                alt='powerpoint logo'
            />
        ),
    },
    {
        label: 'Word',
        videoId: 'a2951e83dee0bb0548846e9dfe35a5eb',
        url: 'https://www.youtube-nocookie.com/embed/DOzALcGJjzw?si=epJu2E6_ev_l3M_s',
        icon: (
            <img
                className='inline-block'
                style={{ height: '30px' }}
                src={WordLogo}
                alt='word logo'
            />
        ),
    },
    {
        label: 'Teams',
        videoId: '3cf78143f88047444ccd87d7a3a5a8bf',
        url: generateCloudFlareVideoUrlByid('3cf78143f88047444ccd87d7a3a5a8bf'),
        icon: (
            <img
                className='inline-block'
                style={{ height: '30px' }}
                src={TeamsLogo}
                alt='teams logo'
            />
        ),
    },
    /*  { label: 'Google Chrome', videoId: '4976422f5b5f1eed1bbf863815f57e4a' }, */
];

const Demonstration = ({ selectedSlide = 0 }) => {
    const [curSlide, setSlide] = useState(selectedSlide);

    return (
        <section id='demo' className='py-12 bg-white sm:py-16 lg:py-20'>
            <div className='px-4 mx-auto max-w-7xl sm:px-6 lg:px-8'>
                <div className='text-center mb-4'>
                    <h2 className='text-3xl font-bold leading-tight text-gray-900 sm:text-4xl xl:text-5xl font-pj'>
                        How it works?
                    </h2>
                    <div className='py-4'>
                        <Segmented
                            value={curSlide}
                            size='large'
                            options={slides.map((s, idx) => ({
                                label: s.label,
                                value: idx,
                                icon: s.icon,
                            }))}
                            onChange={(value) => {
                                setSlide(value);
                            }}
                        />
                    </div>
                    <p className='text-base leading-7 text-gray-600 font-pj'>
                        Sign in with your email and get started now!
                    </p>
                </div>

                <div
                    style={{
                        position: 'relative',
                        paddingTop: '56.25%',
                    }}>
                    <iframe
                        title={`${slides[curSlide].label} - AI Perfect Assistant`}
                        src={slides[curSlide].url}
                        loading='lazy'
                        style={{
                            border: 'none',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                        }}
                        allow='accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;'
                        allowFullScreen
                    />
                </div>
            </div>
            <div className='max-w-lg mx-auto my-8 px-4'>
                <BrowseIntegrationsButton />
            </div>
        </section>
    );
};

export default Demonstration;
